import styled, { keyframes, css } from 'styled-components';
import { TRANSITION_DURATION_MS } from '../../constants';
import { Link } from 'react-router-dom';

const slideDown = keyframes`
 from {
    opacity: 0;
    max-height: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    max-height: 1000px;
    transform: translateY(0);
  }

`;

const navMenuStyles = css`
  display: flex;
  flex-direction: column;
  cursor: pointer;

  .nav-menu-item-wrapper {
    display: flex;
    flex-direction: column;
    row-gap: 4px;
    height: 0;
    overflow: hidden;
  }

  .nav-menu-transition-wrapper {
    transition: max-height ${TRANSITION_DURATION_MS}ms ease-in-out;
    max-height: 0;
    overflow: hidden;
  }

  &.collapsed-navigation-menu {
    row-gap: 0;

    &.open-menu {
      .nav-menu-transition-wrapper {
        margin-top: 0;
      }
    }

    .nav-menu-item-wrapper {
      display: none;
    }
  }

  &.expanded-state-menu {
  }

  &.open-menu {
    .nav-menu-item-wrapper {
      height: 100%;
    }

    .nav-menu-transition-wrapper {
      margin-top: 4px;
      max-height: 1000px;
      animation: ${slideDown} ${TRANSITION_DURATION_MS}ms ease-in-out forwards;
    }
  }

  &.close-menu {
    .nav-menu-transition-wrapper {
      margin-right: 0;
    }
  }
`;

export const StyledNavMenu = styled.div`
  ${navMenuStyles}
`;

export const StyledNavMenuAnchorTag = styled(Link)`
  text-decoration: none;
  row-gap: 4px;
  ${navMenuStyles}
`;
